import { headerAndFooter as config } from '@config';
const template = require('./header-and-footer-configuration.hbs');

module.exports = Backbone.View.extend({
  events: {
    'change [name="page-range"]': 'changePageRange',
    'click [name="page-heading-section"]': 'togglePageHeadingSection',
    'click #hf-button-cancel': 'closeDropdownMenu',
    'click #hf-option--page-numbering--continue': 'toggleContinueEnabled',
    'click #hf-option--page-numbering--start': 'toggleStartAtEnabled',
    'click #hf-option--page-numbering-section': 'togglePageNumberingFieldsEnabled',
    'click #hf-option--page-range': 'onPageRangeClick',
    'keyup #hf-input--page-range-from': 'onPageRangeFromChange',
    'keyup #menu-header-size-input': 'onChangeHeaderSizeInput',
    'keyup #menu-footer-size-input': 'onChangeFooterSizeInput',
    'input #menu-header-size-input': 'onChangeHeaderSizeInput',
    'input #menu-footer-size-input': 'onChangeFooterSizeInput',
    'mouseup #header-size-slider': 'onChangeHeaderSizeInput',
    'mouseup #footer-size-slider': 'onChangeFooterSizeInput',
    'change #hf-option--page-numbering-style': 'onPageNumberingStyleChange',
    'submit #header-and-footer-configuration': 'submitChanges'
  },

  initialize () {
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
    this.render();
    this.form = document.querySelector('#header-and-footer-configuration');
    this.formSubmitButton = this.form.querySelector('#hf-button-save');
    this.formRangeInput = this.form.querySelector('#hf-input--page-range-from');
    this.headerSizeInput = this.form.querySelector('#menu-header-size-input');
    this.footerSizeInput = this.form.querySelector('#menu-footer-size-input');
    this.initialSizeHeader = Number(this.form.querySelector('[name="header-size"]').value);
    this.initialSizeFooter = Number(this.form.querySelector('[name="footer-size"]').value);

    INKIVE.EditorFacade.once('popupmenu.headerFooter.open', () => {
      this.isModalOpened = true;

      INKIVE.EditorFacade.once('popupmenu.hide', () => {
        if (!this.isModalOpened) return;

        this.isModalOpened = false;
        this.closeDropdownMenu();
      });
    });
  },

  closeDropdownMenu () {
    INKIVE.EditorFacade.handle('header_and_footer', 'set_header_size', {
      size: this.initialSizeHeader
    });

    INKIVE.EditorFacade.handle('header_and_footer', 'set_footer_size', {
      size: this.initialSizeFooter
    });

    INKIVE.Menus.elementPopupMenu?.hide?.();
  },

  togglePageHeadingSection (event) {
    const isChecked = event.target.checked;

    this.form.querySelectorAll('[data-group="page-section"]')
      .forEach(element => { element.disabled = !isChecked; });
  },

  onPageRangeFromChange (event) {
    const value = event.target.value;
    const pageRangeRadio = this.form.querySelector('#hf-option--page-range');

    this.formSubmitButton.disabled = pageRangeRadio.checked && !value.length;
  },

  onPageRangeClick (event) {
    const isChecked = event.target.checked;

    this.formRangeInput.disabled = !isChecked;

    if (!this.formRangeInput.value.length) {
      this.formSubmitButton.disabled = true;
    }
  },

  changePageRange (event) {
    const value = event.target.value;
    const isPageRangeSelected = value === 'page-range';

    this.$el.find('[name="page-range-from"]').prop('disabled', !isPageRangeSelected);
    if (!isPageRangeSelected) this.$el.find('[name="page-range-from"]').val('');

    if (!isPageRangeSelected) {
      this.formRangeInput.disabled = true;
      this.formSubmitButton.disabled = false;
    }
  },

  onChangeHeaderSizeInput (event) {
    const currentValue = Number(this.headerSizeInput.value);
    if (currentValue > config.size.max) { this.headerSizeInput.value = config.size.max; }
    if (currentValue < config.size.min) { this.headerSizeInput.value = config.size.min; }

    const maxValue = config.size.max - Number(this.headerSizeInput.value);
    if (Number(this.footerSizeInput.value) > maxValue) { this.footerSizeInput.value = maxValue; }
  },

  onChangeFooterSizeInput (event) {
    const currentValue = Number(this.footerSizeInput.value);
    if (currentValue > config.size.max) { this.footerSizeInput.value = config.size.max; }
    if (currentValue < config.size.min) { this.footerSizeInput.value = config.size.min; }

    const maxValue = config.size.max - Number(this.footerSizeInput.value);
    if (Number(this.headerSizeInput.value) > maxValue) { this.headerSizeInput.value = maxValue; }
  },

  submitChanges (event) {
    event.preventDefault();

    if (event.type !== 'submit') return;

    this.saveChanges(event);
  },

  togglePageNumberingFieldsEnabled (event) {
    const isChecked = event.target.checked;
    const isPageNumberingChecked = this.form.querySelector('#hf-option--page-numbering--start').checked;

    this.form.querySelectorAll('[data-group="page-numbering"]')
      .forEach(element => { element.disabled = !isChecked; });

    this.form.querySelector('[name="start-page-at"]').disabled = !isChecked || !isPageNumberingChecked;
  },

  toggleStartAtEnabled (event) {
    const isChecked = event.target.checked;

    this.form.querySelector('[name="start-page-at"]').disabled = !isChecked;
  },

  _prepareRangeToSave (range, rangeFrom) {
    if (range === 'all') return 'all';
    if (range === 'current-page') return String(INKIVE.PageFactory.getCurrentPageNumber());
    if (range === 'page-range') return rangeFrom;
  },

  toggleContinueEnabled (event) {
    const isChecked = event.target.checked;

    this.form.querySelector('[name="start-page-at"]').disabled = isChecked;
  },

  onPageNumberingStyleChange (event) {
    const value = event.target.value;
    const option = config.pageNumberingStyle.find(style => style.name === value);

    if (option) {
      this.form.querySelector('[name="start-page-at"]').min = Number(option.minValue);
    }
  },

  saveChanges (event) {
    const formData = Object.fromEntries(new FormData(event.target));
    const isPageNumberingOn = formData['page-numbering-section'] === 'on';
    const isPageHeadingOn = formData['page-heading-section'] === 'on';
    const range = this._prepareRangeToSave(formData['page-range'], formData['page-range-from']);
    const headerSize = Number(formData['header-size']);
    const footerSize = Number(formData['footer-size']);

    const settings = {
      odd_and_even: formData['page-odd-evens'] === 'true',
      range,
      heading_section: isPageHeadingOn ? formData['heading-section'] : undefined,
      heading_level: isPageHeadingOn ? Number(formData['page-section-level']) : undefined,
      numbering_section: isPageNumberingOn ? formData['numbering-section'] : undefined,
      numbering_style: isPageNumberingOn ? formData['numbering-style'] : undefined,
      numbering_starts: isPageNumberingOn ? formData['numbering-start'] : undefined,
      numbering_starts_at: isPageNumberingOn && formData['numbering-start'] === 'start' ? Number(formData['start-page-at']) : undefined,
      header_size_percentage: isNaN(headerSize) ? config.initial.size : headerSize ?? config.initial.size,
      footer_size_percentage: isNaN(footerSize) ? config.initial.size : footerSize ?? config.initial.size
    };

    this.initialSizeHeader = settings.header_size_percentage;
    this.initialSizeFooter = settings.footer_size_percentage;

    INKIVE.EditorFacade.handle('header_and_footer', 'set_range', settings);
  },

  _getHeadings (settings) {
    return config.headings.map(heading => ({
      ...heading,
      selected: heading.value === settings.headingLevel
    }));
  },

  _getPageRangeFrom (settings) {
    return settings.pageRangeFrom?.join(',') || '';
  },

  _getNumberingStyles (settings) {
    return config.pageNumberingStyle.map(style => ({
      ...style,
      selected: style.name === settings.numberingStyle
    }));
  },

  _getCurrentPageNumber () {
    return String(INKIVE.PageFactory.getCurrentPageNumber());
  },

  _getHeaderFooterSize () {
    const rangeSettings = INKIVE.EditorFacade.get('header_and_footer', 'range');

    const headerSize = rangeSettings.headerSize ?? config.size.initial;
    const footerSize = rangeSettings.footerSize ?? config.size.initial;

    return {
      header: headerSize,
      footer: footerSize
    };
  },

  _buildSlider () {
    const that = this;
    const size = this._getHeaderFooterSize();
    let headerSize = size.header;
    let footerSize = size.footer;
    const max = config.size.max;
    const min = config.size.min;
    const sizeToNumber = size => Number(size) || 0;

    const headerSlider = $('#header-and-footer-menu--header-size')
      .find('.slider').slider({
        max,
        min,
        value: headerSize,
        slide: (_, ui) => {
          const roundedValue = sizeToNumber(ui.value);
          that.headerSizeInput.value = roundedValue;
          INKIVE.EditorFacade.handle('header_and_footer', 'set_header_size', { size: roundedValue });
        },
        stop: () => {
          that.onChangeHeaderSizeInput();
          footerSlider.slider('option', 'value', that.footerSizeInput.value);
        }
      });
    const footerSlider = $('#header-and-footer-menu--footer-size')
      .find('.slider').slider({
        max,
        min,
        value: footerSize,
        slide: (_, ui) => {
          const roundedValue = sizeToNumber(ui.value);
          that.footerSizeInput.value = roundedValue;
          
          INKIVE.EditorFacade.handle('header_and_footer', 'set_footer_size', { size: roundedValue });
        },
        stop: () => {
          that.onChangeFooterSizeInput();
          headerSlider.slider('option', 'value', that.headerSizeInput.value);
        }
      });

    headerSlider.slider('float');
    footerSlider.slider('float');
  },

  render () {
    const settings = INKIVE.EditorFacade.get('header_and_footer', 'range');
    const hasMultipleRanges = INKIVE.EditorFacade.get('header_and_footer', 'hasMultipleRanges');
    const size = this._getHeaderFooterSize();

    let pageRange;
    let rangeFrom = '';
    if (!hasMultipleRanges && (!settings.range || settings.range === 'all')) {
      pageRange = 'all';
    } else if ((!settings.range && hasMultipleRanges) || (settings.range === this._getCurrentPageNumber())) {
      pageRange = 'current-page';
    } else {
      pageRange = 'page-range';
      rangeFrom = settings.range;
    }

    const templateOptions = {
      rangeFrom,
      pageRange,
      headings: this._getHeadings(settings),
      hasPageHeading: !!settings.headingSection,
      headingSection: settings.headingSection,
      oddAndEven: settings.oddAndEven,
      numberingStyles: this._getNumberingStyles(settings),
      section: settings.numberingSection,
      startsAt: isNaN(settings.numberingStartsAt) ? 1 : settings.numberingStartsAt,
      numberingStart: settings.numberingStarts ?? 'start',
      headerSize: size.header,
      footerSize: size.footer,
      minSize: config.size.min,
      maxSize: config.size.max
    };

    this.$el.html(template(templateOptions));
    this._buildSlider();
  }
});
